<template>
    <div class="modules">
        <b-tabs
            class="management-module-tab apprentice-tab"
            content-class="management-module-tab-content">
            <b-tab
                title="Modules"
                active
                title-item-class="modules-tab">
                <design-2021-module-index-component
                    :modules-in="modulesIn"
                    :tags-in="tagsIn"
                    :education-levels-in="educationLevelsIn"
                    :skill-trees-in="skillTreesIn"
                    :teachers-in="allTeachersIn"
                    :las-groups-in="lasGroupsIn"
                    :module-periods-in="modulePeriodsIn">
                </design-2021-module-index-component>
            </b-tab>

            <b-tab
                v-if="$authUser.hasRole('module') || $authUser.isAdmin()"
                :title="$t('management.administrators')"
                title-item-class="management-tab">
                <design-2021-management-modules-management-component
                    :teachers-in="teachersIn"
                    :teachers-without-module-in="teachersWithoutModuleIn">
                </design-2021-management-modules-management-component>
            </b-tab>

            <b-tab
                v-if="$authUser.hasRole('module') || $authUser.isAdmin()"
                title="Tags"
                title-item-class="tag-tab">
                <design-2021-module-tag-index-component :tags-in="tagsIn"></design-2021-module-tag-index-component>
            </b-tab>
            <b-tab
                :title="$t('management.time_blocks')"
                title-item-class="period-tab">
                <design-2021-module-period-index-component
                    :module-periods-in="modulePeriodsIn"
                    :periods-in="periodsIn"></design-2021-module-period-index-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-management-modules-component',
    props: [
        'teachersIn',
        'modulesIn',
        'tagsIn',
        'educationLevelsIn',
        'skillTreesIn',
        'allTeachersIn',
        'teachersWithoutModuleIn',
        'lasGroupsIn',
        'periodsIn',
        'modulePeriodsIn',
    ],
};
</script>

<style scoped lang="scss"></style>
